import { ImageApi } from "../openapi";
import openApiConfig from "./http_service";

const imageApi=new ImageApi(openApiConfig)

export default imageApi